import { ENTRY_BUTTON, WIDGET, ENTRY } from '../../constants/entityTypes';
import { UPDATE, DELETE } from '../../constants/actionsTypes';
import ChangeModel from '../../models/ChangeModel';
import changesQueueInstance from '../ChangesQueue';

class EntryButtonChangeManager {
  changesQueue: typeof changesQueueInstance;
  entityType: string;

  constructor(changesQueue) {
    this.changesQueue = changesQueue;
    this.entityType = ENTRY_BUTTON;
  }

  update(beforeUpdate, afterUpdate, widgetId, entryId) {
    const dependencies = new Map([
      [WIDGET, widgetId],
      [ENTRY, entryId],
    ]);
    const change = new ChangeModel(
      this.entityType,
      UPDATE,
      beforeUpdate,
      afterUpdate,
      dependencies,
    );

    return this.changesQueue.addChange(change);
  }

  delete(entity, widgetId, entryId) {
    const dependencies = new Map([
      [WIDGET, widgetId],
      [ENTRY, entryId],
    ]);
    const change = new ChangeModel(
      this.entityType,
      DELETE,
      entity,
      null,
      dependencies,
    );

    return this.changesQueue.addChange(change);
  }
}

export default new EntryButtonChangeManager(changesQueueInstance);
